










































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";

@Component
export default class ImplementasiTable extends Vue {
  @Prop({ type: String, default: "45vh" }) height!: string;
  @Prop({ type: Array, default: () => [] }) implementationList!: any[];
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: Boolean, default: false }) readonly: boolean;
  @Prop({ type: Object, default: null }) deletingItem!: number | null;

  get user() {
    return userModule.user;
  }

  canManage(item: any): boolean {
    if (userModule.hasPrivilege("implementasi-askep", "update")) return true;

    return !!item.user && Number(item.user.id) === Number(this.user.id);
  }

  isDeleting(item: any): boolean {
    return this.deletingItem === (item.id || null);
  }

  onEditImplementation(item: any, idx: number) {
    this.$emit("editImplementation", item, idx);
  }

  onDeleteImplementation(item: any, idx: number) {
    this.$emit("deleteImplementation", item, idx);
  }
}
